import React, { useCallback, useEffect, useRef, useState } from "react";
import MainLayout from "../layout/main-layout";
import EditorJS from "@editorjs/editorjs";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import Loader from "../Components/loader/loader";
import UserViewEditor from "../Components/Editor/user-view-editor";
import moment from "moment";

function UserDetailBlog() {
  const [blog, setBlog] = useState<any>({});
  const [randomBlog, setRandomBlog] = useState<any>({});
  const [loading, setLoading] = useState(true);
  const editorRef = useRef<EditorJS | null>(null);
  const { id } = useParams();

  const handleFetchBlogData = useCallback(() => {
    Promise.allSettled([
      axios.get(`/blogs/random`, {
        params: {
          blog_id: id,
          is_article: false,
        },
      }),
      axios.get(`/blogs/${id}`),
    ])
      .then(([randomRes, currentRes]) => {
        if (randomRes.status === "fulfilled") {
          setRandomBlog(randomRes?.value?.data);
        }
        if (currentRes.status === "fulfilled") {
          setBlog(currentRes?.value?.data);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [id, setLoading]);

  useEffect(() => {
    handleFetchBlogData();
  }, [handleFetchBlogData]);

  return (
    <MainLayout>
      <section className="min-h-screen h-full w-full p-8 md:p-16 overflow-hidden relative flex flex-col items-center justify-center">
        {loading ? (
          <Loader />
        ) : (
          <div className="py-20 flex items-center justify-between">
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
              <div className="lg:col-span-3">
                <div className="p-6 md:p-8">
                  <div className="mb-8">
                    <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
                      {blog?.title}
                    </h1>
                    <div className="flex items-center text-gray-600 text-sm">
                      <span>By {blog?.written_by || "Unknown Author"}</span>
                      <span className="mx-2">•</span>
                      <span>{moment(blog?.date).format("DD-MM-YYYY")}</span>
                    </div>
                    <span className="my-12 text-sm text-gray-600">
                      {blog.brief}
                    </span>
                    <img
                      src={blog?.poster_img_url}
                      className="my-10 rounded-2xl h-[450px] w-full"
                    />
                  </div>

                  <div className="prose flex max-w-7xl">
                    <UserViewEditor
                      editorRef={editorRef}
                      data={blog?.content}
                    />
                  </div>
                </div>
              </div>

              <div className="lg:col-span-1">
                <div className="sticky top-4">
                  <h2 className="text-xl font-bold text-gray-800 mb-6">
                    Recommended Reads
                  </h2>

                  <div className="space-y-4">
                    {randomBlog?.id ? (
                      <div
                        key={randomBlog?.id}
                        className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden"
                      >
                        {randomBlog?.poster_img_url && (
                          <div className="aspect-video w-full overflow-hidden">
                            <img
                              src={randomBlog.poster_img_url}
                              alt={randomBlog?.title || "Blog post"}
                              className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                              onError={(e) => {
                                const target = e.target as HTMLImageElement;
                                target.src = "/placeholder-image.jpg";
                              }}
                            />
                          </div>
                        )}

                        <div className="p-4">
                          <h3 className="font-semibold text-gray-800 text-sm leading-tight mb-2 line-clamp-2">
                            <Link
                              to={`/blogs/${randomBlog?.title}/${randomBlog?.id}`}
                              className="hover:text-blue-600 transition-colors duration-200"
                            >
                              {randomBlog?.title || "Untitled"}
                            </Link>
                          </h3>

                          <div className="flex items-center text-xs text-gray-500">
                            <span>
                              By {randomBlog?.written_by || "Unknown"}
                            </span>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="text-center text-gray-500 py-8">
                        <p>No recommended posts available</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
    </MainLayout>
  );
}

export default UserDetailBlog;
